import { addToCart, throttle } from '@nova/utils'

document.addEventListener('DOMContentLoaded', () => {
  const $formWrapper = document.querySelector('.js-product-qty-atc-wrapper')
  const $sizeGuideBtns =
    document.querySelectorAll('.js-size-guide-button') || []
  const $sizeGuideDrawer = document.querySelector('.js-size-guide-drawer') || []

  if ($formWrapper) {
    function handleATCClass(atcBtn) {
      const $qtyAtcContainer = document.querySelector('.js-product-qty-atc-wrapper')
      const $qtyAtcWrapper = document.querySelector('.product__quantity_and_buy_buttons')
      const fixedButtonClass = 'addtocart-fixed-mobile'
      const currentScrollPosition =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0

      const shouldShowFixedButton =
        (currentScrollPosition + 120 < $qtyAtcContainer.offsetTop || currentScrollPosition + 120 > $qtyAtcContainer.offsetTop + window.innerHeight) &&
        $qtyAtcWrapper
      atcBtn.classList.toggle(fixedButtonClass, shouldShowFixedButton)
    }

    function fixedAddCart() {
      const $addToCartBtn = document.querySelector('[data-scroll-fixed]')
      if ($addToCartBtn) {
        handleATCClass($addToCartBtn)
        window.addEventListener('scroll', () =>
          throttle(handleATCClass($addToCartBtn), 20)
        )
      }
    }

    function getActiveSwatch() {
      return document.querySelector('[name="color"]:checked')?.dataset.value || ''
    }

    function findMatchingSampleVariant(sampleProduct) {
      if (sampleProduct === null) return null

      const variantSelectors = document.querySelectorAll('.js-variant-picker .js-options-input:checked')
      const selectedOptions = Array.from(variantSelectors).map(selector => selector.dataset.value)
      const [firstOpt, secondOpt, thirdOpt] = selectedOptions

      let matchedVariants = sampleProduct.variants.filter((variant) => variant.option1 === firstOpt)
      const [matchedVariant] = matchedVariants
      if (matchedVariants.length === 1) return matchedVariant

      matchedVariants = matchedVariants.filter((variant) => variant.option2 === secondOpt)
      const [matchedVariant2] = matchedVariants
      if (matchedVariants.length === 1) return matchedVariant2
      else if (matchedVariants.length === 0) return matchedVariant

      matchedVariants = matchedVariants.filter((variant) => variant.option3 === thirdOpt)
      const [matchedVariant3] = matchedVariants
      if (matchedVariants.length === 1) return matchedVariant3
      else if (matchedVariants.length === 0) return matchedVariant2
      else return null
    }

    // Sample product functionality
    async function handleSampleAddClick(event) {
      const button = event.target.closest('.sample-add-button')
      const sampleHandle = button.dataset.sampleReference
      const currentSwatch = getActiveSwatch()

      if (!sampleHandle || !currentSwatch) {
        console.error('Sample not available')
        return
      }

      try {
        button.classList.add('loading')
        button.setAttribute('disabled', true)

        const variantsTemplate = document.querySelector('#sample-product-json')
        const sampleProduct = variantsTemplate
          ? JSON.parse(variantsTemplate.content.textContent.trim())
          : null
        const currentSwatch = getActiveSwatch()
        const matchingVariant = findMatchingSampleVariant(sampleProduct)

        if (matchingVariant && matchingVariant.available) {
          const cartData = await fetch('/cart.js').then(r => r.json())
          const sampleCount = cartData.items.reduce((total, item) => {
            total += item.properties['_is_sample'] ? item.quantity : 0
            return total
          }, 0)

          const samplePrice = sampleCount < 7 ? 0 : 100 // $0 for first 6, $1.00 after

          await addToCart({
            id: matchingVariant.id,
            quantity: 1,
            properties: {
              _is_sample: true,
              _sample_pricing: samplePrice > 0 ? 'paid' : 'free'
            }
          })
        } else {
          console.error('Sample not available for selected options')
        }
      } catch (error) {
        console.error('Unable to add sample to cart')
      } finally {
        button.removeAttribute('disabled')
        button.classList.remove('loading')
      }
    }

    function checkSampleAdd(enabled) {
      const $sampleButton = document.querySelector('.sample-add-button')
      if ($sampleButton) {
        if (enabled) {
          const variantsTemplate = document.querySelector('#sample-product-json')
          const sampleProduct = variantsTemplate
            ? JSON.parse(variantsTemplate.content.textContent.trim())
            : null
          const currentSwatch = getActiveSwatch()
          const matchingVariant = findMatchingSampleVariant(sampleProduct)
          if (matchingVariant) {
            if (matchingVariant.available) $sampleButton.removeAttribute('disabled')
            else $sampleButton.setAttribute('disabled', true)
          }
        } else {
          $sampleButton.setAttribute('disabled', true)
        }
      }
    }

    function onAddSampleToCart() {
      const $sampleAddButton = document.querySelector('.sample-add-button')
      if ($sampleAddButton) {
        $sampleAddButton.addEventListener('click', (event) => handleSampleAddClick(event))
      }
    }

    document.addEventListener('nova:product:render-additional-actions', (event) => {
      const { enabled } = event.detail
      checkSampleAdd(enabled)
    })

    function renderForm() {
      if($formWrapper) {
        const $form = $formWrapper.querySelector('.js-product-form')
        if ($form) {
          const $submitButton = $form.querySelector('[type="submit"]')
          const $quantityInput = document.querySelector(
            `nova-quantity-input[data-form-id=${$form.getAttribute('id')}]`,
          )
          $form.addEventListener('submit', async (event) => {
            event.preventDefault()

            $submitButton.setAttribute('disabled', true)
            $submitButton.classList.add('loading')

            const formData = new FormData($form)
            const id = formData.get('id')
            const quantity = $quantityInput?.value || 1
            const properties = {}

            const customCalContainer = document.querySelector('nova-custom-calculator-values')
            const customWItem = $form.querySelector('[name="properties[_custom_width]"]')
            const customHItem = $form.querySelector('[name="properties[_custom_length]"]')
            if (customCalContainer && customWItem && customHItem && customWItem.value.trim() !== '' && customHItem.value.trim() !== '') {
              const w = Number(customWItem.value)
              const h = Number(customHItem.value)
              if (w && h && w > h) {
                customCalContainer.swapSize(w, h)
              }
            }

            // Extract all properties from form data
            for (const [key, value] of formData.entries()) {
              if (key.startsWith('properties[') && value) {
                // Convert "properties[_custom_width]" to "_custom_width"
                const propertyKey = key.replace('properties[', '').replace(']', '')
                properties[propertyKey] = value
              }
            }

            // Check Side mark
            const $sideMark = document.querySelector('.js-product-side-mark')
            if ($sideMark && $sideMark.value.length) {
              properties['Side Mark'] = $sideMark.value
            }

            // Check if sample
            const productTagsTemplate = document.querySelector(
              '#product-tags-json',
            )
            const productTags = productTagsTemplate
              ? JSON.parse(productTagsTemplate.content.textContent.trim())
              : []
            if (productTags.includes('sample')) {
              const cartData = await fetch('/cart.js').then(r => r.json())
              const sampleCount = cartData.items.reduce((total, item) => {
                total += item.properties['_is_sample'] ? item.quantity : 0
                return total
              }, 0)
              const samplePrice = sampleCount < 7 ? 0 : 100 // $0 for first 6, $1.00 after
              properties['_is_sample'] = true
              properties['_sample_pricing'] = samplePrice > 0 ? 'paid' : 'free'
            }

            addToCart({ id, quantity, properties }).then(() => {
              $submitButton.removeAttribute('disabled')
              $submitButton.classList.remove('loading')

              if ($submitButton.hasAttribute('fb-sample-handle')) {
                $submitButton.setAttribute('disabled', true)
                document.querySelector('.js-max-qty-error-message').classList.remove('hidden')
              }
            })
          })

          document.dispatchEvent(
            new CustomEvent('nova:product:render-additional-actions', {
              detail: { enabled: true },
            }),
          )
        } else {
          document.dispatchEvent(
            new CustomEvent('nova:product:render-additional-actions', {
              detail: { enabled: false },
            }),
          )
        }
      }
    }

    fixedAddCart()
    renderForm()
    onAddSampleToCart()

    document.addEventListener('nova:product:render-form', (event) => {
      const content = event.detail.html

      if (!content) return
      document.querySelector('.js-product-qty-atc-wrapper').innerHTML = content.innerHTML

      fixedAddCart()
      renderForm()
    })

    async function reloadMiniCart() {
      try {
        const productHandle = document.querySelector('.js-product-qty-atc-wrapper').dataset.productHandle
        const response = await fetch(`/products/${productHandle}?view=cart`)
        const text = await response.text()
        const html = new DOMParser().parseFromString(text, 'text/html')
        const content = html.querySelector('.view-mini-cart').innerHTML
        const $miniCartContainer = document.querySelector('.js-mini-cart-container')
        if ($miniCartContainer) {
          $miniCartContainer.innerHTML = content
        }
      } catch (error) {
        console.error('Error:', error.message)
      }
    }

    document.addEventListener('nova:cart:reload', (event) => {
      reloadMiniCart()
    })
  }

  if ($sizeGuideDrawer) {
    for (const $button of $sizeGuideBtns) {
      $button.addEventListener('click', () => {
        if ($sizeGuideDrawer.hasAttribute('open')) {
          $sizeGuideDrawer.hide()
        } else {
          $sizeGuideDrawer.show()
        }
      })
    }
  }

  document.addEventListener('nova:product:render-title', (event) => {
    const content = event.detail.html

    if (!content) return
    document.querySelector('.js-product-title').innerHTML = content.innerHTML
  })

  document.addEventListener('nova:product:remove-from-cart', (event) => {
    const { handle } = event.detail
    const $submitButton = document.querySelector('.js-product-form .js-product-buy-button[type="submit"]')
    if ($submitButton && $submitButton.hasAttribute('fb-sample-handle')) {
      if ($submitButton.getAttribute('fb-sample-handle') === handle) {
        $submitButton.removeAttribute('disabled')
        document.querySelector('.js-max-qty-error-message').classList.add('hidden')
      }
    }
  })
})
